<template>
  <div id="app">
    <router-view v-if="isRouterAlive">
      <index></index>
    </router-view>
  </div>
</template>
<script>
  import Index from './components/Index.vue'
  export default {
    components: {
      Index
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
    }
  }
</script>

<style lang="less">
  @import "assets/css/default.css";
  @import "assets/css/common.css";

  #app {
    font-family: Helvetica, Arial, sans-serif, Microsoft Yahei, 'Times New Roman', Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    // font-size: 2vh;
    height: 100%;
  }

  @media screen and (min-width:50rem) {
    // #app {
    //   width: 800px;
    //   width:100%;
    //   margin: 10px auto;
    // }
    #app {
      width:100%;
      margin: 0;
    }
  }
  html,body{
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
		&::-webkit-scrollbar{
			// height: 0;
			// width: 0px;
			// background-color: #F5F5F5;
		}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue